const isMonthly = (interval: string): boolean => interval === 'month';

export default isMonthly;
